
import { ExecutionStatus } from './execution-status';

export class ExecutionStatusSuccess extends ExecutionStatus {

    public isSuccess(): boolean {
        return true;
    }
}
